import { TextTreatmentFlow } from "../text_treatments/text_treatments";
import { TextTreatmentElement } from "../text_treatments/text_treatments";

export class ChatTreatment extends HTMLElement {
  constructor(showParent) {
    super();
    this.showParent = showParent;
  }
  connectedCallback() {
    this.innerHTML = 
      `
      <style>
        chat-treatment {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      </style>
      <div class="row">
        <div class="chat_treatment_details slide_adjust_col_8">
          <h3><span class="title">Create</span> Chat Treatment</h3>
          <p>Build your text treatment</p>
          <div class="errors"></div>
          <div class="form-group" style="margin:10px 0px;">
            <label>Name</label>
            <input type="text" class="form-control" id="treatment_title" placeholder="Name">
          </div>
        </div>
      </div>
      <div class="row" id="chat_treatment_flow">
        <div class="treatments_container slide_adjust_col_8">
          <text-treatment-flow>
            <text-treatment-element></text-treatment-element>
          </text-treatment-flow>
        </div>
      </div>
      <div class="row">
        <div class="slide_adjust_col_8 buttons">
          <input id=SaveCallTreatment type=button value='Save' class='btn btn-primary pull-right' title=Save>
          <input id=CancelCallTreatment type=button value='Cancel' class='btn btn-outline-secondary pull-right' title=Cancel>
        </div>
      </div>
      `;

    this.querySelector("#SaveCallTreatment").addEventListener('click', this.save.bind(this));
    this.querySelector("#CancelCallTreatment").addEventListener('click', this.cancel.bind(this));
  }

  cancel() {
    this.remove();
    $("#call_treatment_path").hide();
    $("#call_treatments_list").show();
    this.showParent();
  }

  async loadCallTreatment(id) {
    panel_refresh($('#call_treatment_path'));
    this.treatment_id = id;
    let domain_id = document.querySelector("#object_id").value
    // let res = await fetch('/admin/domains/'+domain_id+'/call_treatments/'+id);
    let res = await fetch(`/admin/domains/${domain_id}/message_treatments/${id}`);
    let data = await res.json();
    this.message_tree_id = data.message_tree_id;
    this.querySelector("#treatment_title").value = data.description;

    this.querySelector(".treatments_container").innerHTML = "<text-treatment-flow></text-treatment-flow>";
    let flow = this.querySelector(".treatments_container > text-treatment-flow")
    flow.renderFlow(data.message);

    panel_refresh($('#call_treatment_path'));
  }

  async save() {
    let validationResult = this.validate();
    // parse validationResult
    this.querySelector(".chat_treatment_details .errors").innerHTML = ''
    if(validationResult.requiredMissing == true || validationResult.errorMessages.length > 0) {
      let errorMessages = ``;
      if(validationResult.requiredMissing == true) {
        errorMessages += `<div class="alert alert-danger alert-dismissible" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <strong>Warning!</strong> The Call Treatment is incomplete.
          </div>`
      }
      validationResult.errorMessages.forEach(function(errorMessage) {
        errorMessages += `<div class="alert alert-danger alert-dismissible" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <strong>Warning!</strong> ${errorMessage}
          </div>`
      });

      this.querySelector(".chat_treatment_details .errors").innerHTML = errorMessages;
    } else {
      panel_refresh($('#call_treatment_path'));  // UNCOMMENT
      let child = {message_type: null, text: null, message_responses:[]}
      // The first target is just a container for the rest of the targets.
      let treatment = {
        message_tree : {
          message_tree_id: this.message_tree_id ? this.message_tree_id : null,
          message_tree_type: "CHAT",
          description: $("#treatment_title").val(),
          message: child
        }
      }
      
      this.querySelector("text-treatment-flow").getData(child);

      let domain_id = document.querySelector("#object_id").value
      let res = await fetch('/admin/domains/'+domain_id+'/message_treatments', {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                    'Content-type': 'application/json'},
          method: 'POST',
          body: JSON.stringify(treatment)
        })
      let data = await res.json();
      if(data.success) {
        panel_refresh($('#call_treatment_path'));
        panel_refresh($('#call_treatments_list'));
        this.cancel();
        TreatmentsManager.reloadTreatments(() => panel_refresh($('#call_treatments_list')));
      } else {
        alert("Sorry an error occured and was unable to save.");
        panel_refresh($('#call_treatment_path'));
      }

    }

  }

  validate() {
    let validationResult = this.querySelector("text-treatment-flow").validate();
    this.querySelector("#treatment_title").classList.remove("error");
    if(this.querySelector("#treatment_title").value == "") {
      this.querySelector("#treatment_title").classList.add("error");
      validationResult.requiredMissing = true
    }

    return validationResult
  }
}

customElements.define('chat-treatment', ChatTreatment)

// export class TextTreatmentFlow extends HTMLElement {

//   constructor() {
//     super();
//   }

//   validate(required_flow=true) {
//     let validationResult = {requiredMissing: false, errorMessages: []}
//     if(required_flow || this.children[0].nodeName != "TEXT-TREATMENT-ELEMENT") {
//       this.children.forEach((element, i) => {
//         let elementValidation = element.validate();
//         if(elementValidation.requiredMissing) {
//           validationResult.requiredMissing = true;
//         }
//         Array.prototype.push.apply(validationResult.errorMessages, elementValidation.errorMessages);
//       });
//     }
//     return validationResult;
//   }

//   hasData() {
//     return this.children[0].nodeName != "TEXT-TREATMENT-ELEMENT";
//   }

//   getData(child) {
//     let current_child = child;
//     this.children.forEach((element, i) => {
//       if(element.nodeName == "HANGUP-TREATMENT") {
//         // Hangup treatment has no data so continue to POST-CALL-TREATMENT
//         return;
//       }

//       if(element.isTarget()) {
//         current_child.destination = element.getData();
//       } else if(element.nodeName == "POST-CALL-TREATMENT") {
//         current_child.actions.push(...element.getData());
//       } else {
//         current_child.actions.push(element.getData());
//       }

//       // Figure out what to do with the next target/action
//       if(this.children.length > (i+1) && element.isTarget()) {
//         // Check to see if there are child elements.
//         let next_child = this.children[i+1].nodeName;
//         if(next_child != "HANGUP-TREATMENT" && next_child != "POST-CALL-TREATMENT" ) {
//           current_child.destination.children.push({ivr_option: null, destination: null, actions: []})
//           current_child = current_child.destination.children[0];
//         }
//       }
//     });
//   }

//   renderFlow(child) {
//     this.renderImmediateActions(child.target_child_actions);
//     this.renderTarget(child.destination);
//     if((child.destination != null && child.destination.children != null && child.destination.children.length == 0) && !TextTreatmentFlow.isEndpoint(child.destination)) {
//       this.renderTarget(); // render Hangup
//       let post_call_treatment = document.createElement('post-call-treatment')
//       post_call_treatment.child_actions = child.target_child_actions;
//       this.appendChild(post_call_treatment);
//     } else if(!TextTreatmentFlow.isEndpoint(child.destination)) {
//       if(child.destination.children != null) {
//         this.renderFlow(child.destination.children[0])
//       } else {
//         this.renderTarget()
//         let post_call_treatment = document.createElement('post-call-treatment')
//         post_call_treatment.child_actions = child.target_child_actions;
//         this.appendChild(post_call_treatment);
//       }
//     } else if(TextTreatmentFlow.isOutboundEndpoint(child.destination) || child.destination == null) {
//       let post_call_treatment = document.createElement('post-call-treatment')
//       post_call_treatment.child_actions = child.target_child_actions;
//       this.appendChild(post_call_treatment);
//     }
//   }

//   renderImmediateActions(child_actions) {
//     child_actions.forEach((child_action) => {
//       if(child_action.action_timing == 1) {
//         let action = child_action.action
//         if(action.action_type == SMSTreatment.getType()) {
//           let smsAction = document.createElement('sms-treatment');
//           smsAction.action = action;
//           this.appendChild(smsAction);
//         } else if(action.action_type == WebhookTreatment.getType()) {
//           let webhookAction = document.createElement("webhook-treatment");
//           webhookAction.action = action;
//           this.appendChild(webhookAction);
//         } else {
//           console.log("Error occured with: " + action)
//         }
//       }
//     });
//   }

//   renderTarget(target)  {
//     if(target == null || typeof target == "undefined") {
//       let newElement = document.createElement('hangup-treatment');
//       this.appendChild(newElement);
//     }
//     else {
//       let newElement = null;
//       switch(target.target_type) {
//         case PlainTextTreatment.getType():
//           newElement = document.createElement('plain-text-treatment');
//           break;
//         case TransferTeamTreatment.getType():
//           newElement = document.createElement('transfer-team-treatment');
//           break;
//         case PauseTreatment.getType():
//           newElement = document.createElement('pause-treatment');
//           break;
//         case TextTodTreatment.getType():
//           newElement = document.createElement('text-tod-treatment');
//           break;
//         case QuestionTreatment.getType():
//           newElement = document.createElement('question-treatment');
//       }

//       newElement.target = target;
//       this.appendChild(newElement)
//     }
//   }

//   replace(oldElement, action_type="") {
//     let newElement = null;
//     let addNewAction = false; // Some elments allow followup actions.
//     let logo = ''
//     switch(action_type) {
//       case "question":
//         newElement = document.createElement('question-treatment');
//         break;
//       case "plain_text":
//         addNewAction = true;
//         newElement = document.createElement('plain-text-treatment');
//         break;
//       case "transfer_to_team":
//         newElement = document.createElement('transfer-team-treatment');
//         break;
//       case "pause":
//         addNewAction = true;
//         newElement = document.createElement('pause-treatment');
//         break;
//       case "end_conversation":
//         newElement = document.createElement('end-conversation-treatment');
//         break;
//       case "text_tod":
//         newElement = document.createElement('text-tod-treatment');
//         break;
//       default:
//         newElement = document.createElement('text-treatment-element');
//     }

//     if(newElement != null) {
//       this.replaceChild(newElement, oldElement);
//       if(addNewAction) {
//         this.appendChild(document.createElement('text-treatment-element'))
//       }
//       console.log(typeof this.flowChanged  === 'undefined');
//       if(!(typeof this.flowChanged  === 'undefined')) {
//         this.flowChanged(this, newElement);
//       }
//     } else {
//       console.log("Error occured");
//     }
//   }
// }
// customElements.define('text-treatment-flow', TextTreatmentFlow);

// export class TextTreatmentElement extends HTMLElement {
//   constructor(show_hangup = false) {
//     super();
//     this.show_only_actions = false;

//   }

//   connectedCallback() {
//     this.first_child = this.closest("text-treatment-flow").children.length <= 1;
//     let flow = this.closest("text-treatment-flow");
//     this.innerHTML =
//     `<div class="col-sm-12 ct_action" data-action_type=NEW>
//       <div class="panel panel-default">
//         <h4>Choose an Action</h4>
//         <div class="col-sm-3">
//           <div class="well" data-action_type="question">Ask a Question
//           <i class="fa fa-question-circle" style="width: 100%; font-size: 2em;"></i>
//           </div>
//         </div>
//         <div class="col-sm-3">
//           <div class="well" data-action_type="plain_text">Send Message
//           <i class="fa fa-align-left" style="width: 100%; font-size: 2em;"></i>
//           </div>
//         </div>
//         <div class="col-sm-3">
//           <div class="well" data-action_type="transfer_to_team">Transfer to Team
//           <i class="fa fa-arrow-circle-right" style="width: 100%; font-size: 2em;"></i>
//           </div>
//         </div>
//         <div class="col-sm-3">
//           <div class="well" data-action_type="pause">Pause
//           <i class="fa fa-pause-circle" style="width: 100%; font-size: 2em;"></i>
//           </div>
//         </div>
//         <div class="col-sm-3">
//           <div class="well" data-action_type="end_conversation">End Conversation
//           <i class="fa fa-times-circle" style="width: 100%; font-size: 2em;"></i>
//           </div>
//         </div>
//         <div class="col-sm-3">
//           <div class="well" data-action_type="text_tod">Schedule
//           <i class="fa fa-clock-o" style="width: 100%; font-size: 2em;"></i>
//           </div>
//         </div>
//       </div>
//     </div>`;
//     let _this = this;
//     this.querySelectorAll(".well").forEach(function(elem) {elem.addEventListener('click', function() {
//       _this.closest("text-treatment-flow").replace(_this, this.dataset.action_type);
//     });});
//   }

//   validate() {
//     // For sure a validation error as you cannot have empty targets.
//     this.querySelector(".ct_action").classList.add("error");
//     return {requiredMissing: true};
//   }
// }

// customElements.define('text-treatment-element', TextTreatmentElement);